// dependencies
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { currentUserQuery } from "../../../api/queries/defs/auth";

// api
import { meResponseSchema } from "../../services";
import { PYUseQueryOptions } from "../StandardQueryArguments";

export const useCurrentUser = (options?: PYUseQueryOptions<z.infer<typeof meResponseSchema>>) => {
	return useQuery<z.infer<typeof meResponseSchema>>(currentUserQuery(options));
};
